export const EVENT_DATA = {
  event: [
    {
      title: '부스트캠프 웹·모바일 7기',
      preset: '이벤트',
      tag: ['교육', '웹/프론트엔드', '벡엔드', '모바일'],
      host: '네이버 커넥트 재단',
      date: null,
      period: '06. 02(목) ~ 06. 21(화) 11:00',
      link: 'https://blog.naver.com/boostcamp_official/222743073202',
    },
    {
      title: 'NVIDIA AI 개발자 밋업 - TAO Toolkit',
      preset: '이벤트',
      tag: ['온라인', '머신러닝/AI'],
      host: 'NVIDIA',
      date: '06. 21(화) 14:00 ~ 16:00',
      period: null,
      link: 'https://festa.io/events/2348',
    },
    {
      title: 'Welcome to AI World Meetup #1',
      preset: '이벤트',
      tag: ['오프라인', '머신러닝/AI'],
      host: 'Welcome to AI',
      date: '06. 21(화) 14:00 ~ 16:00',
      period: null,
      link: 'https://festa.io/events/2348',
    },
    {
      title: '현대자동차 연구개발본부 AI 경진대회',
      preset: '이벤트',
      tag: ['경진대회', '머신러닝/AI'],
      host: '현대자동차',
      date: null,
      period: '05. 25(수) ~ 06. 22(수)',
      link: 'https://festa.io/events/2348',
    },
    {
      title: 'Welcome to AI World Meetup #1',
      preset: '이벤트',
      tag: ['교육', '벡엔드', '모바일'],
      host: '원티드',
      date: null,
      period: '06. 08(수) ~ 06. 22(수)',
      link: 'https://festa.io/events/2363',
    },
    {
      title: '네이버 IT직군 특집 #코딩테스트/기술면접',
      preset: '이벤트',
      tag: ['온라인', '커리어'],
      host: '캐치',
      date: '06. 23(목) 20:00 ~ 21:30',
      period: null,
      link: 'https://www.catch.co.kr/CatchClass/Live/View/5260',
    },
    {
      title: '카카오 응용분석팀 & 추천팀 채용설명회',
      preset: '이벤트',
      tag: ['온라인', '커리어'],
      host: '카카오',
      date: '06. 23(목) 20:00 ~ 22:00',
      period: null,
      link: 'https://careers.kakao.com/jobs/P-12703',
    },
    {
      title: 'Microsoft Build 2022 After Party',
      preset: '이벤트',
      tag: ['세미나'],
      host: 'Microsoft MVP Community',
      date: '06. 25(토) 13:00 ~ 17:00',
      period: null,
      link: 'https://festa.io/events/2378',
    },
    {
      title: '디스콰이엇 메이커톤',
      preset: '이벤트',
      tag: ['해커톤'],
      host: '디스콰이엇',
      date: '06. 24(금) 19:00 ~ 06. 26(일) 15:00',
      period: null,
      link: 'https://festa.io/events/2356',
    },
    {
      title: 'GDG 썸머 해커톤 : 오프티벌',
      preset: '이벤트',
      tag: ['해커톤'],
      host: 'GDG Campus Korea',
      date: '06. 25(토) 11:30 ~ 06. 26(일) 16:00',
      period: null,
      link: 'https://festa.io/events/2314',
    },
    {
      title: 'ESG 아이디어톤 참가자 모집',
      preset: '이벤트',
      tag: ['해커톤'],
      host: '현대모비스',
      date: null,
      period: '06. 07(화) ~ 06. 26(일)',
      link: 'https://mobisthon.com/',
    },
    {
      title: '세번째 마켓컬리 개발자 Meet Up',
      preset: '이벤트',
      tag: ['온라인'],
      host: '마켓컬리',
      date: null,
      period: '06. 13(월) ~ 06. 26(일)',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLSednRT-LrcR-VHbyfQi3yKmslVpTmDEsTCiWmnaOozv5Ll4Vw/viewform',
    },
    {
      title: '카카오엔터프라이즈와 함께 하는 K-Digital Training 5기',
      preset: '이벤트',
      tag: ['교육'],
      host: '구름',
      date: '05. 30(월) ~ 06. 27(월)',
      period: null,
      link: 'https://allforyoung.com/posts/16729/',
    },
    {
      title: '골프존 테크 아카데미 - Front-end / Back-end 개발 코스',
      preset: '이벤트',
      tag: ['교육'],
      host: '골프존 테크 아카데미',
      date: '06. 14(화) ~ 06. 27(월)',
      period: null,
      link: 'https://golfzon.recruiter.co.kr/app/jobnotice/view?systemKindCode=MRS2&jobnoticeSn=101661',
    },
    {
      title: '카카오 데이터정보플랫폼팀 & 광고추천팀 채용설명회',
      preset: '이벤트',
      tag: ['온라인', '커리어'],
      host: '카카오',
      date: '06. 27(목) 20:00 ~ 22:00',
      period: null,
      link: 'https://careers.kakao.com/jobs/P-12703',
    },
    {
      title: 'NHN Cloud make IT',
      preset: '이벤트',
      tag: ['오프라인', '클라우드'],
      host: 'NHN Cloud',
      date: '06. 28(화) 10:00 ~ 18:00',
      period: null,
      link: 'https://metaversedev.kr/info/',
    },
    {
      title: '2022 휴먼이해 인공지능 논문경진대회',
      preset: '이벤트',
      tag: ['경진대회', 'AI'],
      host: '에트리',
      date: '03. 16(토) ~ 06. 30(일)',
      period: null,
      link: 'https://aifactory.space/competition/detail/2006',
    },
    {
      title: '2022 청년일다방 온오프라인 잡콘서트, 넉넉위크',
      preset: '이벤트',
      tag: ['온라인', '교육'],
      host: '성동구',
      date: '06. 27(월) ~ 06. 30(목)',
      period: null,
      link: 'https://mewing-almandine-c08.notion.site/2022-1b2f3ff7fd754fad96d7ebf7251ba506',
    },
    {
      title: '캐치 커리어콘 OO테크',
      preset: '이벤트',
      tag: ['온라인', '커리어', 'AI'],
      host: '캐치',
      date: '06. 28(화) ~ 06. 30(목)',
      period: null,
      link: 'https://www.catch.co.kr/CatchClass/CareerCon',
    },
    {
      title: 'Google I/O Extended 2022 Cloud Busan',
      preset: '이벤트',
      tag: ['오프라인', '클라우드'],
      host: 'GDG Cloud Busan',
      date: '06. 30(목) 18:30 ~ 22:00',
      period: null,
      link: 'https://festa.io/events/2389',
    },
    {
      title: 'Depromeet 11th 최종 발표회',
      preset: '이벤트',
      tag: ['세미나', '오프라인'],
      host: '디프만',
      date: '07. 02(토) 14:00 ~ 17:00',
      period: null,
      link: 'https://festa.io/events/2367',
    },
    {
      title: '부스트코스 코칭스터디 ‘모두를 위한 파이썬(PY4E 2022)’ 모집',
      preset: '이벤트',
      tag: ['교육'],
      host: '커넥츠재단',
      date: '07. 02(토) 14:00 ~ 17:00',
      period: null,
      link: 'https://apply.connect.or.kr/connect/applyDetail?annoId=20008486',
    },
    {
      title: 'AIAI: Deep Learning Summer School',
      preset: '이벤트',
      tag: ['교육', 'AI'],
      host: 'AIAI',
      date: null,
      period: '06. 16(목) ~ 07. 06(수)',
      link: 'https://festa.io/events/2391',
    },
    {
      title: 'D2 CAMPUS PARTNER',
      preset: '이벤트',
      tag: ['교육'],
      host: '네이버 D2',
      date: null,
      period: '06. 13(월) ~ 07. 08(금)',
      link: 'https://d2.naver.com/news/6671933',
    },
    {
      title: '제 9회 SW개발보안 경진대회',
      preset: '이벤트',
      tag: ['경진대회'],
      host: '행정안전부',
      date: null,
      period: '06. 20(월) ~ 07. 29(금)',
      link: 'https://securecoding.software/',
    },
    {
      title: '2022 Hello New( ) World 해커톤대회',
      preset: '이벤트',
      tag: ['해커톤'],
      host: '신세계 아이앤씨',
      date: '06. 03(금) ~ 07. 05(화)',
      period: null,
      link: 'http://hellonewworld.co.kr/',
    },
    {
      title: '2022 전자정부표준프레임워크 컨트리뷰션',
      preset: '이벤트',
      tag: ['경진대회', 'AI'],
      host: '행정안전부',
      date: '03. 28(월) ~ 07. 31(일)',
      period: null,
      link: 'https://www.egovframe.go.kr/home/ntt/nttRead.do?pagerOffset=0&searchKey=&searchValue=&menuNo=74&bbsId=6&nttId=1849',
    },
    {
      title: '2022 인프콘',
      preset: '이벤트',
      tag: ['컨퍼런스', '오프라인'],
      host: '인프런',
      date: '08. 26(금) 13:00 ~ 18:00',
      period: null,
      link: 'https://infcon.day/teaser',
    },
    {
      title: '제5회 KB국민은행 소프트웨어 경진대회',
      preset: '이벤트',
      tag: ['경진대회'],
      host: 'KB국민은행',
      date: '05. 02(월) ~ 09. 16(금)',
      period: null,
      link: 'https://www.kbsccoding.com/',
    },
    {
      title: 'JSConf Korea',
      preset: '이벤트',
      tag: ['오프라인', '웹/프론트엔드', '벡엔드'],
      host: 'JSConf',
      date: '09. 16(목) ~ 09. 17(금)',
      period: null,
      link: 'https://2022.jsconf.kr/ko',
    },
    {
      title: '파이콘 한국 2022',
      preset: '이벤트',
      tag: ['컨퍼런스', '온라인', '오프라인'],
      host: '파이콘 한국',
      date: '10. 01(토) ~ 10. 02(일)',
      period: null,
      link: 'https://2022.pycon.kr/',
    },
    {
      title: '제7회 롯데멤버스 빅데이터 경진대회',
      preset: '이벤트',
      tag: ['경진대회', '빅데이터'],
      host: '롯데맴버스',
      date: '06. 29(수)',
      period: null,
      link: 'https://aifactory.space/competition/detail/2063',
    },
    {
      title: '2022 오픈소스 컨트리뷰션 아카데미 멘티모집',
      preset: '이벤트',
      tag: ['오픈소스'],
      host: '과학기술정보통신부',
      date: null,
      period: '06. 15(수) ~ 06. 17(금)',
      link: 'https://www.oss.kr/notice/show/cf492935-9cf2-4755-98d8-e1ea6aae7abd',
    },
    {
      title: 'Korea Spring Meetup with Josh Long',
      preset: '이벤트',
      tag: ['온라인', '프레임워크'],
      host: 'VMware Tanzu Korea',
      date: '06. 22(수)',
      period: null,
      link: 'https://www.facebook.com/events/602837658152152/',
    },
    {
      title:
        '쿠버네티스 네트워킹을 통해 가동시간을 늘리고, 고객 환경을 개선하는 방법',
      preset: '이벤트',
      tag: ['교육', '백엔드'],
      host: '디지털투데이',
      date: '06. 23(목) 14:00 ~ 15:00',
      period: null,
      link: 'http://www.digitaltoday.co.kr/bbs/view.html?idxno=85&sc_category=',
    },
    {
      title: 'Flutter I/O Extended Korea 2022',
      preset: '이벤트',
      tag: ['온라인', '모바일'],
      host: 'Flutter Korea',
      date: null,
      period: '06. 26(일) 14:00 ~ 17:00',
      link: 'https://festa.io/events/2361',
    },
    {
      title: '메타버스엑스포 2022',
      preset: '이벤트',
      tag: ['기타'],
      host: '(주)메쎼이상',
      date: '06. 15(수) ~ 06. 17(금)',
      period: null,
      link: 'https://metavexpo.com/visitor/registration/',
    },
    {
      title: '넥스트 라이즈 2022 서울',
      preset: '이벤트',
      tag: ['기타'],
      host: '넥스트라이즈',
      date: '06. 15(수) ~ 06. 17(금)',
      period: null,
      link: 'https://nextrise.co.kr/ko/about/about',
    },
    {
      title: '하시코프 사용자 모임 2022년 6월 서울 밋업',
      preset: '이벤트',
      tag: ['기타'],
      host: 'HashiCorp 한국사용자모임',
      date: '06. 22(수) 20:00 ~ 22:00',
      period: null,
      link: 'https://festa.io/events/2383',
    },
    {
      title: '2022년 현대모비스 알고리즘 경진대회',
      preset: '이벤트',
      tag: ['기타'],
      host: '현대모비스',
      date: '05. 20(금) ~ 06. 24(금)',
      period: null,
      link: 'https://allforyoung.com/posts/16398/',
    },
    {
      title: '2022 메타버스 개발자 경진대회',
      preset: '이벤트',
      tag: ['기타'],
      host: '과학기술정보통신부',
      date: '05. 31(화) ~ 06. 28(화)',
      period: null,
      link: 'https://metaversedev.kr/info/',
    },
  ],
  meeting: [
    {
      title: '스프린트 서울',
      preset: '모임',
      tag: ['오픈소스'],
      link: 'https://sprintseoul.org/',
    },
    {
      title: 'DevOps Korea',
      preset: '모임',
      tag: ['인프라/DevOps'],
      link: 'https://www.facebook.com/groups/TeAnE/',
    },
    {
      title: 'Serverless Korea',
      preset: '모임',
      tag: ['클라우드'],
      link: 'https://event-us.kr/bsBxCcQJioWM/event',
    },
    {
      title: 'Google Developers Experts',
      preset: '모임',
      tag: ['모바일'],
      link: 'https://developers.google.com/community/experts ',
    },
    {
      title: 'GDG Golang korea',
      preset: '모임',
      tag: ['클라우드'],
      link: 'https://developers.google.com/community/experts ',
    },
    {
      title: 'Data Scientist Meetup in Seoul',
      preset: '모임',
      tag: ['데이터'],
      link: 'https://www.meetup.com/ko-KR/Data-Scientist-Meetup-in-Seoul/',
    },
    {
      title: 'IT인프라 엔지니어 그룹',
      preset: '모임',
      tag: ['웹/프론트엔드', '백엔드'],
      link: 'https://www.facebook.com/groups/InfraEngineer/',
    },
    {
      title: 'GDG DevFest Seoul',
      preset: '모임',
      tag: ['웹/프론트엔드', '백엔드'],
      link: 'https://www.facebook.com/devfest.seoul.2019/',
    },
    {
      title: 'OSS 개발자 포럼',
      preset: '모임',
      tag: ['오픈소스'],
      link: 'https://www.facebook.com/groups/ossdevforum',
    },
    {
      title: '오픈 인프라',
      preset: '모임',
      tag: ['인프라/DevOps'],
      link: 'http://oidc.co.kr/',
    },
    {
      title: 'FinOps Korea',
      preset: '모임',
      tag: ['인프라/DevOps'],
      link: 'https://www.facebook.com/groups/finops.community1',
    },
    {
      title: 'React Korea',
      preset: '모임',
      tag: ['웹/프론트엔드', '프레임워크'],
      link: 'https://www.facebook.com/groups/react.ko/',
    },
    {
      title: 'Vuejs Korea',
      preset: '모임',
      tag: ['웹/프론트엔드', '프레임워크'],
      link: 'https://vuejs-kr.github.io/',
    },
    {
      title: 'Node.js Korea',
      preset: '모임',
      tag: ['웹/프론트엔드', '백엔드'],
      link: 'https://www.facebook.com/groups/nodejskr',
    },
    {
      title: 'Django Girls Seoul',
      preset: '모임',
      tag: ['백엔드', '프레임워크'],
      link: 'https://djangogirls.org/seoul/',
    },
    {
      title: 'OSXDev.org',
      preset: '모임',
      tag: ['모바일'],
      link: 'https://www.facebook.com/groups/osxdevorg/',
    },
    {
      title: 'GDG Korea WebTech',
      preset: '모임',
      tag: ['웹/프론트엔드', '백엔드'],
      link: 'https://www.facebook.com/groups/webTechKR/',
    },
    {
      title: 'KSUG - 한국 스프링 사용자 모임',
      preset: '모임',
      tag: ['프레임워크'],
      link: 'https://www.ksug.org/',
    },
    {
      title: 'devocean',
      preset: '모임',
      tag: ['인프라/DevOps'],
      link: 'https://www.ksug.org/',
    },
    {
      title: 'OpenStack Korea 커뮤니티',
      preset: '모임',
      tag: ['오픈소스'],
      link: 'https://www.facebook.com/groups/openstack.kr',
    },
    {
      title: 'Ceph 한국 커뮤니티',
      preset: '모임',
      tag: ['오픈소스'],
      link: 'https://www.facebook.com/groups/620899444961207',
    },
    {
      title: 'Open Compute Project 한국 커뮤니티',
      preset: '모임',
      tag: ['인프라/DevOps'],
      link: 'https://www.facebook.com/groups/ocpkorea/',
    },
    {
      title: '표준프레임워크 오픈커뮤니티',
      preset: '모임',
      tag: ['프레임워크'],
      link: 'https://open.egovframe.org/',
    },
    {
      title: '게임 서버 개발자 모임',
      preset: '모임',
      tag: ['교육', '모바일'],
      link: 'https://www.facebook.com/groups/207844736374114/',
    },
    {
      title: 'Kubernetes Korea',
      preset: '모임',
      tag: ['백엔드'],
      link: 'https://www.facebook.com/groups/k8skr/',
    },
    {
      title: 'KubernPostgreSQL Korea',
      preset: '모임',
      tag: ['데이터'],
      link: 'https://www.facebook.com/groups/postgres.kr',
    },
    {
      title: '한국 리눅스 사용자 그룹',
      preset: '모임',
      tag: ['교육'],
      link: 'https://www.facebook.com/groups/korelnxuser/',
    },
    {
      title: 'Korea Elasticsearch User Group',
      preset: '모임',
      tag: ['클라우드'],
      link: 'https://www.facebook.com/groups/elasticsearch.kr/',
    },
    {
      title: 'Kotlin Korea',
      preset: '모임',
      tag: ['모바일'],
      link: 'https://www.facebook.com/groups/kotlinkr/',
    },
    {
      title: '구글 Flutter 한국 사용자 그룹',
      preset: '모임',
      tag: ['모바일'],
      link: 'https://www.facebook.com/groups/flutterkorea/',
    },
    {
      title: 'Kaggle Korea',
      preset: '모임',
      tag: ['머신러닝/AI'],
      link: 'https://www.facebook.com/groups/kotlinkr/',
    },
    {
      title: '파이토치 한국 사용자 모임',
      preset: '모임',
      tag: ['머신러닝/AI', '프레임워크'],
      link: 'https://pytorch.kr/',
    },
    {
      title: 'Girls In Tech Korea',
      preset: '모임',
      tag: ['교육'],
      link: 'https://korea.girlsintech.org/',
    },
    {
      title: 'OKKY (Java,Spring)',
      preset: '모임',
      tag: ['프레임워크'],
      link: 'https://okky.kr/',
    },
    {
      title: '남궁성의 코드초보 스터디(Java,C)',
      preset: '모임',
      tag: ['교육'],
      link: 'https://cafe.naver.com/javachobostudy',
    },
    {
      title: '우분투 한국 커뮤니티',
      preset: '모임',
      tag: ['교육'],
      link: 'https://ubuntu-kr.org/',
    },
    {
      title: '안드로이드개발',
      preset: '모임',
      tag: ['모바일'],
      link: 'https://www.facebook.com/groups/androidcode/',
    },
    {
      title: '닷넷데브',
      preset: '모임',
      tag: ['프레임워크'],
      link: 'https://www.dotnetconf.kr/history',
    },
    {
      title: 'GraphQL Korea',
      preset: '모임',
      tag: ['웹/프론트엔드'],
      link: 'https://www.facebook.com/groups/graphql.kr',
    },
  ],
};
